export const createAdUnitCode = (slotName) => {
	let _adData;

	const { adData = {}, adDataAdc } = window.tagEngineDataLayer;

	if (adDataAdc) {
		_adData = adDataAdc;
	} else {
		const pageFromPath = window.location.pathname.replace('/app', '').replaceAll('/', '');
		const pageId = pageFromPath || 'home';
		_adData = adData[pageId];
	}

	if (_adData?.adSlots) {
		let adUnitCode = Object.values(_adData.adSlots)[0].adUnitCode.split('/');
		adUnitCode[4] = slotName;
		return adUnitCode.join('/').replace('-p', '').replace('-v', '');
	}

	return '';
};
